import config from 'config';

import React from 'react';
// i18next
import { useTranslation } from 'react-i18next';
// MUI
import { makeStyles } from '@mui/styles';
import { Box } from '@mui/material';
// Components
import Title from 'components/Title';
// Framer
import { motion } from 'framer-motion';
import { bottomAnimate, topAnimate } from 'utilities/Framer';

const Contacts:React.FC = () => {
  const classes = useStyles();
  const { t } = useTranslation('common');

  const { phoneNumber, adressLabel, adressLink } = config;

  return (
    <motion.section
      data-container="contacts"
      className={classes.block}
      initial="hidden"
      whileInView="visible"
      viewport={{ amount: 0.2 }}
    >
      <div className={[classes.blockContent, 'container'].join(' ')}>
        <motion.div variants={bottomAnimate} custom={1}>
          <Title>{t('homePage.contacts.getInTouch')}</Title>
        </motion.div>
        <motion.h2
          className={classes.title}
          variants={topAnimate} custom={1}
        >{t('homePage.contacts.title')}</motion.h2>
        <Box className={classes.contactBlock}>
          <div className={classes.contactBlockItem}>
            <h3 className={classes.contactBlockSubtitle}>{t('homePage.contacts.locationAddress')}</h3>
            <a href={adressLink} target="_blank" rel="noreferrer" className={classes.contactBlockText}>
              {adressLabel}
            </a>
          </div>
          <div className={classes.contactBlockItem}>
            <h3 className={classes.contactBlockSubtitle}>{t('homePage.contacts.phoneNumber')}</h3>
            <a href={`tel:${phoneNumber.replace(/\s+/g, '')}`} className={classes.contactBlockText}>{phoneNumber}</a>
          </div>
          <div className={classes.contactBlockItem}>
            <h3 className={classes.contactBlockSubtitle}>{t('homePage.contacts.emailAddress')}</h3>
            <a href="mailto:termoclinic@gmail.com" className={classes.contactBlockText}>termoclinic@gmail.com</a>
          </div>
        </Box>
      </div>
    </motion.section>
  );
}

export default Contacts;

const useStyles = makeStyles({
  block: {
    position: 'relative',
    padding: '16px',
    '@media (min-width: 600px)': {
      padding: '32px'
    },
    '@media (min-width: 1240px)': {
      padding: '40px 32px'
    },
  },
  blockContent: {
    paddingTop: '20px',
    '@media (min-width: 600px)': {
      paddingTop: '32px',
    },
    '@media (min-width: 1240px)': {
      paddingTop: '56px',
    },
  },
  title: {
    color: '#0e073c',
    letterSpacing: '1px',
    fontSize: '34px',
    textAlign: 'center',
    margin: '20px 0 40px 0',
    '@media (min-width: 600px)': {
      fontSize: '40px',
    },
    '@media (min-width: 1240px)': {
      fontSize: '60px',
    },
  },
  contactBlock: {
    width: '100%',
    backgroundColor: '#0e073b',
    padding: '40px 30px',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    '@media (min-width: 1240px)': {
      padding: '60px 40px',
      flexDirection: 'row',
      justifyContent: 'space-between',
      gap: '40px'
    },
  },
  contactBlockItem: {
    padding: '12px 0',
    borderBottom: 'rgba(255, 255, 255, 0.07) solid 1px',
  },
  contactBlockSubtitle: {
    fontSize: '18px',
    color: '#a39ccf',
    fontWeight: 600,
  },
  contactBlockText: {
    fontSize: '16px',
    color: '#c9c5e8',
    fontWeight: 500,
    display: 'inline-block',
    padding: '6px 0',
    transition: 'color 0.3s',

    '&:hover': {
      color: '#fff'
    }
  }
});
